import { render, staticRenderFns } from "./MapCompetition.vue?vue&type=template&id=05ca652e&scoped=true&"
import script from "./MapCompetition.vue?vue&type=script&lang=js&"
export * from "./MapCompetition.vue?vue&type=script&lang=js&"
import style0 from "./MapCompetition.vue?vue&type=style&index=0&id=05ca652e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca652e",
  null
  
)

export default component.exports